import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'TextContent',
})(({ spacing, breakpoints, typography }) => ({
  content: {
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: spacing(2),
    [breakpoints.up('sm')]: {
      paddingTop: spacing(3),
    },
    [breakpoints.up('md')]: {
      paddingTop: 0,
    },
  },
  headline: {
    marginBottom: spacing(1),
  },
  body: {
    paddingRight: 0,
    marginBottom: spacing(2),
    [breakpoints.up('md')]: {
      paddingRight: spacing(5),
    },
  },
  ctaContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: typography.pxToRem(8),
  },
  cta: {
    maxWidth: typography.pxToRem(141),
  },
  qrCodeContainer: {
    display: 'flex',
    gap: spacing(0),
  },
  appLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(-1),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
